    export var resourceStrings = {
        appId: 'Microsoft App ID',
        featuredBotsTitle: 'Featured bots',
        directoryHeroTitle: 'Meet the bots',
        directoryHeroText: 'Say hello! Try out a bot and add it to your favorite conversation\u00a0experiences.',
        botBuilder: 'Bot Builder',
        botConnector: 'Bot Connector',
        botDirectory: 'Bot Directory',
        botEndpoint: 'Messaging endpoint',
        botEnableStreamingEndpoint: 'Enable Streaming Endpoint',
        botSchemaTransformationVersion: 'Schema Transformation Version:',
        botEndpointBlank: 'Not set',
        botFramework: 'Bot Framework',
        botFrameworkExtended: 'Microsoft Bot Framework',
        botId: 'Bot handle',
        maximize: 'Expand',
        minimize: 'Done',
        cancel: 'Cancel',
        edit: 'Edit',
        register: 'Register',
        deleteBot: 'Delete bot',
        channelTestLink: 'Test link',
        channelLog: 'Issues',
        channelEnabled: 'Enabled',
        channelPublished: 'Published',
        readMore: 'Read more.',
        readLess: 'Read less.',
        learnMore: 'Learn more',
        buttonOk: 'OK',
        buttonCancel: 'Cancel',
        buttonNo: 'No',
        buttonYes: 'Yes',
        botDisclaimer: "Your interactions with this bot are also subject to the conversational channel's applicable terms of use, privacy and data collection policies.",

        v3LandingTitle: 'Get building',
        v3LandingTexts: {
            sdk: { title: 'Build a great bot', text: 'Download the SDKs for Node.js, .NET or REST; leverage the chat emulator and more\u2026' },
            channels: { title: 'Connect to channels', text: 'Connect your bot to the world\'s best conversation experiences.' },
            directory: { title: 'Meet the bots', text: 'Visit the Bot Directory, try a bot, and add it to your favorite conversation experiences.' },
            congnitive: { title: 'Add smarts with Cognitive Services', text: 'Enable your bot to see, hear and interpret in more human ways.' },
            skype: { title: 'Build a Skype bot', text: 'Make the world\'s conversations rich, productive, and fun.' },
            teams: { title: 'Build a Teams bot', text: 'Microsoft Teams is the chat-based workspace for Office 365.' },
            //docs: {title: 'Learn bot basics', text: 'Everything you need to know about creating a great conversational bot.'}
        },
        v3Update: "This bot is no longer compatible with the Bot Framework. Update your bot now to get it working again.",
        v3Warning: "We revised our security protocols on July 31, 2017. Update to Bot Builder 3.9+ or compatible security configuration to keep your bot working.",
        tooltips: {
            channelConfig: {
                title: 'Skype and Web chat channels have been auto configured.',
                text: 'Click \'Edit\' to fine tune channel specific capabilities and settings.'
            }
        },
        errors: {
            noMarketsSelected: 'You must select at least one market',
            agreementNotChecked: 'You must agree to the Privacy Statement, Terms of Use, and Code of Conduct.'
        },
        botPageTabs: ['Develop', 'Channels', 'Settings', 'Publish'],
        initializing: 'Initializing',
        loadingBotApp: 'Loading bot app',
        deployingBotApp: 'Deploying bot app',
        botEditorUpdated: 'Bot registration updated',
        botSettingsUpdated: 'Bot updated',
        msaAppSecret: 'App secret',
        msaDescription: 'In order to authenticate your bot with the Bot Framework, you\'ll need to register your application and generate an App ID and password.',
        msaLabelRegister: 'Register your bot with Microsoft to generate a new App ID and password',
        msaLearnMore: 'Learn how to create a new App Registration',
        msaLabelPasteAppId: 'Paste your app ID below to continue',
        msaLabelPasteAppIdAndPwd: 'Paste your App ID and password below to continue',
        loadingBotWebChat: 'Loading chat interface\u2026',
        subscriptionConsentDialog: {
            title: "Subscribe to Microsoft Bot Framework",
            description: "Let's keep in touch! Signup to receive the latest news about Microsoft Bot Framework, bots and more.",
            selectCountryLabel: "Select your country/region:",
            agreementHeading: "Terms of service",
            agreementDescription: "Please read and agree to the following terms.  NOTICE: The Online Services Terms do not apply to publication on channels.  For example, terms for publication on Microsoft channels do not offer data processing terms.",

            /**
             * NOTE
             * ----
             * These labels label show up as is using raw HTML of body label, be careful while editing this string.
             * If you are not sure don't add any useless tags.
             */
            allowPromotionalEmailLabelHtml: "Contact me with promotional offers and updates about Microsoft Bot Framework services.",

            /**
             * NOTE
             * ----
             * This map is country specific terms and conditions HTML that we might need to show for special cases.
             * Populate HTML carefuly against each country code (Must be capital)
             */
            countrySpecificPromotionalEmailLablesHtml: {
                CA: 'I would like to hear from Microsoft and its family of companies via email and phone about Bot Framework and other Microsoft products and services. ' +
                    'To withdraw consent or manage your contact preferences, visit the <a href="https://go.microsoft.com/fwlink/?LinkId=243191" targe="_blank">Promotional Communications Manager</a>. '
            },

            /**
             * NOTE
             * ----
             * this label goes in as is setting HTML of body label, be careful while editing this string.
             * If you are not sure don't add any useless tags.
             */

            agreementLabelHtml: 'I agree that my use of the Bot Framework service is subject to the same <a href="https://azure.microsoft.com/en-us/support/legal/" target="_blank">terms under which I use the Azure Bot Service through Azure</a>.  If I do not use the Azure Bot Service through Azure, I agree that my use of this service is subject to the <a href="https://go.microsoft.com/?linkid=9840733" target="_blank">Microsoft Online Service Terms</a>.  By using the Bot Framework service, I acknowledge the <a href="//aka.ms/bf-privacy" target="_blank">Privacy & Cookies statement</a>.',
            luisAgreementLabelHtml: 'I agree that this service is subject to <a href="https://azure.microsoft.com/en-us/support/legal/" target="_blank">the same terms under which I subscribe to Cognitive Services through Azure</a>, including the <a href="https://www.microsoft.com/en-us/Licensing/product-licensing/products.aspx" target="_blank">Online Services Terms</a>. I acknowledge the <a href="https://go.microsoft.com/fwlink/?LinkId=521839" target="_blank">Privacy & Cookies statement</a>.',

            saveButtonLabel: "Save",
            cancelButtonLabel: "Cancel",

            updateErrorMessage: "Unable to update your subscription preferences"
        },
        iframeTitleLuis: "Language Understanding Intelligent Service",
        iframeTitleQna: "QnA Maker",
        v4: {
            // Must be kept in sync with enum BotTabs of Client/Views/v4/BotPage.tsx
            // Note: the last entry is 'Build' the enum value is BotTabs.Develop, this is by design
            botPageTabs: ['Build', 'Analytics', 'Settings', 'Channels', 'Build'],
            analyticsNotConfigured: "You haven't enabled Analytics via Azure Application Insights yet.",
            nobotsPrompt: "You don't have any bots or skills yet.",
            newBotPrompt: "Create a bot or skill.",
            createBotSDKLink: "Download the Bot Builder SDK",
            createBotLabel: "Build a bot using the Bot Builder SDK and optionally provision your bot in Microsoft Azure."
        },

        channels: {
            published: "Published",
            health: "Health",
            name: "Name",
            edit: "Edit",
            configure: "Configure",
            running: "Running",
            issuesTemplate: "Issues (<%= length %>)",
            warningTemplate: "Warnings (<%= length %>)"
        },

        embedPanel: {
            title: "Bot embed code",
            description: "Choose a channel to get the embed code for it. Copy and paste the code to your website.",
            facebookFooter: "In order to use this embed Facebook requires you to include their JavaScript SDK in your page.",
        },

        channelConfig: {
            deleteMessage: "This action will delete all channel configuration information. Are you sure you want to proceed?",
            deleteHeader: "Delete channel",
            deleteOk: "Yes, delete it",
            deleteCancel: "No, keep it",
            leaveMessage: "You have unsaved changes in this document. Are you sure you want to navigate away from this page?",
            leaveHeader: "Discard changes",
            leaveOk: "Yes, leave page",
            leaveCancel: "No, stay on page",
        },
        expiredAzureSubscription: 'Your Azure subscription is no longer active',

        announcements: {
            types: {
                error: "Error",
                good: "Normal",
                info: "Information",
                warn: "Warning"
            },
            ok: {
                productArea: 'All Bot Framework services',
                text: 'Services are operating normally.'
            },
            link: "See details"
        }
    };



// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Views/Strings.ts